import React, { Component } from "react";

export default class Footer extends Component {
	render() {
		return (<div className={this.props.className ? "footer " + this.props.className :"footer"}>
					{this.props.children}
            	</div>)

	}
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/Footer.js